import { render, staticRenderFns } from "./DetailMerchant.vue?vue&type=template&id=558a9adc"
import script from "./DetailMerchant.vue?vue&type=script&lang=js"
export * from "./DetailMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports